import { useQuery } from "@tanstack/react-query";
import { getUserStatus, userStatusQueryKey } from "@api/user.api";
import { hasAccessToken } from "@lib/auth0";

export function useUserStatus() {
    return useQuery({
        queryKey: [userStatusQueryKey],
        queryFn: getUserStatus,
        staleTime: 60_000,
        refetchOnWindowFocus: false,
        enabled: hasAccessToken(),
    });
}
